module.exports = __webpack_public_path__ + "media/images/bg/mosaic/shodo-c124d9fe00d7ee102dbb4e0e98e96d70.jpg";